import { createContext } from 'react'
import arms from '../game-data/arms.json'
import slots from '../game-data/slots.json'
import boons from '../game-data/boons.json'


export const AppContext = createContext({
  isLightTheme: !(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
  loggedIn: false,
  arms,
  slots,
  boons,
})
